import React, { useState, useEffect } from "react";

import {
  Container,
  Stack,
  Button,
  Drawer,
} from "@mui/material";
import ChartViewPort from "./ChartViewPort";
import {
  getOptions,
  ScenarioUrl_spec,
  ftchPlus,
} from "./Account_urls.jsx";
import { InputAccountsTypesNames } from "../Components/Inputs/Account_TypesNames";
import { errorCheckForm, errorJsonHasErrors, errorSet } from "../Components/Inputs/Input_Fns";
import { set } from "lodash";
import { ErrorBar } from "../Components/ErrorBar";
import { Help_CompareScenario } from "../Dialogs/Help/Help_Inputs";
import { GoogleAnalyticsEvent } from "../Components/ga4.jsx";
import { TopOffset } from "./Navbar_bs.jsx";

export const ChartCompareInput2 = ({ form, avail, nt_Change, onSubmit, errors, setErrors }) => {

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    slotProps: {
      paper: {
        sx: {
          maxHeight: ITEM_HEIGHT * 8.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    }
  };
  return (

    <Stack sx={{ m: 4, mt: TopOffset }} spacing={2}>



      <InputAccountsTypesNames
        avail={avail}
        inputForm={form}
        onChange={nt_Change}
        MenuProps={MenuProps}
        both_allowed={true}
        onError={(e) => errorSet(errors, setErrors, "accounts", 0, e)}
      />
      <Button sx={{ mt: TopOffset, mb: 10, width: 260 }} variant="contained" onClick={onSubmit}>
        Comparison
      </Button>


    </Stack>
  )
}

export const ChartCompareInput = ({
  clientJson,
  show,
  onClose,
  onChart,
  uuid_1,
  uuid_2,
}) => {
  const [doValidation, setDoValidation] = useState(0)
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [cshow, setCShow] = useState(false);
  const [charts, setCharts] = useState([]);

  const [avail, setAvail] = useState({
    AccountNames: [],
    AccountTypes: [],
  });
  const [form, setForm] = useState({
    AccountNames: [],
    AccountTypes: [
      "Est-Residual",
      "InvAssets",
      "Liabilities",
      "NetWorth",
      "Property",
      "NonRegistered",
      "RRSP",
      "TFSA",
    ],
  });

  const getInputData = () => {
    var url = ScenarioUrl_spec(clientJson, uuid_1, "chartinput");
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          console.log(avail);
          let a = {
            ...avail,
            AccountNames: json.Avail.AccountNames,
            AccountTypes: json.Avail.AccountTypes,
          };
          console.log(a);
          setAvail(a);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    slotProps: {
      paper: {
        sx: {
          maxHeight: ITEM_HEIGHT * 8.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    }
  };

  const l_Change = (e) => {
    console.log(e.target.value);

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  const lm_Change = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;

    console.log(values);
    setForm({
      ...form,
      [e.target.name]: values,
    });
  };

  useEffect(() => {
    console.log("CCI");
    if (show) {
      getInputData();
    }
  }, [show]);

  const onChartSubmit = () => {
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      let types =
        form.AccountTypes.length === 0 ? "" : "&accountTypes=" + String(form.AccountTypes);
      let names =
        form.AccountNames.length === 0
          ? ""
          : "&accountNames=" + String(form.AccountNames);
      let chart1 = {
        name: "Scenario Comparison",
        chart: "linechart",
        arg: "?cmp=" + uuid_1 + types + names,
      };
      let chart2 = {
        name: "Scenario Comparison Diff",
        chart: "diffchart/",
        arg: "?cmp=" + uuid_1 + types + names,
      };

      GoogleAnalyticsEvent("chart", "view", "compare", { action: "compare" })

      setCharts([chart1, chart2]);
      setCShow(true);
      console.log(chart1);
    }
  };

  const onInputDiff = () => {
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      let chart1 = {
        name: "Scenario Input Diff",
        chart: "diffinput/" + uuid_1,
        arg: ""
      };

      setCharts([chart1]);
      setCShow(true);
    }
  }

  const nt_Change = (names, types) => {

    let n = typeof names === "string" ? names.split(",") : names;
    console.log(names);
    let t = typeof names === "string" ? types.split(",") : types;
    console.log(types);
    setForm({
      ...form,
      ["AccountNames"]: n,
      ["AccountTypes"]: t,
    });

  };

  const validate = (f) => {
    let ne = structuredClone(errors)
    let err = (f.sweep === "") ? "Please select Sweep Type" : ""
    ne = set(ne, "sweep", err)

    setErrors(ne)
  }

  useEffect(() => {
    validate(form)
  }, [doValidation])


  return (
    <Drawer anchor="left" open={show} onClose={onClose}>
      <Container maxWidth="true">
        <ChartCompareInput2
          onSubmit={onChartSubmit}
          form={form}
          avail={avail}
          nt_Change={nt_Change}
          errors={errors}
          setErrors={setErrors}
        />

        <Stack sx={{ m: 4, mt: TopOffset }} spacing={2}>
          <Button sx={{ mt: TopOffset, mb: 10 }} variant="contained" onClick={onChartSubmit}>
            Comparison
          </Button>
          {/* <Input_label

            value={form.label}
            onChange={l_Change}
            //disabled={true}
            required={false}
            onError={(e) => { setDoValidation(doValidation + 1); errorSet(errors, setErrors, "label", 0, e) }}
          /> */}

          <InputAccountsTypesNames
            avail={avail}
            inputForm={form}
            onChange={nt_Change}
            MenuProps={MenuProps}
            both_allowed={true}
            onError={(e) => errorSet(errors, setErrors, "accounts", 0, e)}
          />

          {/* <Button variant="contained" onClick={onInputDiff}>
            Show Input Differences
          </Button> */}
        </Stack>
      </Container>
      <ChartViewPort
        clientJson={clientJson}
        show={cshow}
        onClose={() => setCShow(false)}
        chart={charts}
      />
      <ErrorBar error={errmsg} />
      <Help_CompareScenario />
    </Drawer>
  );
};

